import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import usePayment from 'hooks/usePayment';
import styles from './style.module.css';
import { CardNumber, Cvv, ExpiryDate, Frames } from 'frames-react';
import { Spinner } from '../../index';
import * as Types from '../../../helpers/types';
import useQuery from '../../../hooks/useQuery';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AddCardFormContent } from '../../../services/content';

const AddNewCheckoutCardForm = ({ scriptLoading, frameLoading }) => {
  let query = useQuery();
  const history = useHistory();
  const dispatch = useDispatch();

  const [, , , , , postSaveCheckoutCard] = usePayment();
  const [isScriptLoading, setScriptLoading] = React.useState(scriptLoading);
  const [isFrameLoading, setFrameIsLoading] = React.useState(frameLoading);
  const [showCVVInfo, setCVVInfo] = React.useState(false);
  const [cardNumberError, setCardNumberError] = React.useState(true);
  const [cardExpiryError, setCardExpiryError] = React.useState(true);
  const [CVVError, setCVVError] = React.useState(true);
  const [showValidationErrors, setShowValidationErrors] = React.useState(false);

  useEffect(() => {
    let script = document.createElement('script');
    script.src = 'https://cdn.checkout.com/js/framesv2.min.js';
    script.async = true;
    script.onload = () => setScriptLoading(false);
    document.body.appendChild(script);
  }, []);

  const accountView = query.get('view') === 'account' ? true : false;

  const saveCard = async function (token) {
    try {
      const newCardDetails = await postSaveCheckoutCard(token);
      dispatch({ type: Types.PAYMENT_SET, payload: newCardDetails });
      accountView ? history.goBack() : history.push('/pharmacy/dashboard/payment');
    } catch (e) {
      history.push('/pharmacy/error');
    }
  };

  const displayCVVInfo = () => {
    return (
      <div>
        <button type="button" className={styles.link_button} href="#" onClick={() => setCVVInfo(!showCVVInfo)}>
          {AddCardFormContent.displayCVVLinkText}
        </button>
        {showCVVInfo ? (
          <div className={styles.info_container}>
            <h2 className={styles.info_header}>{AddCardFormContent.displayCVVTitleText}</h2>
            <p className={styles.info_intro_text}>{AddCardFormContent.displayCVVIntroText}</p>
          </div>
        ) : null}
      </div>
    );
  };

  const setErrors = (e) => {
    switch (e.element) {
      case 'card-number':
        setCardNumberError(!e.isValid);
        break;
      case 'expiry-date':
        setCardExpiryError(!e.isValid);
        break;
      case 'cvv':
        setCVVError(!e.isValid);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {isFrameLoading && <Spinner />}
      <div className={isFrameLoading ? styles.invisible : null}>
        {!isScriptLoading && (
          <>
            <div className={styles.inputContainer}>
              <Frames
                config={{
                  debug: false,
                  publicKey: window.CHECKOUT_PUBLIC_KEY,
                  localization: {
                    cardNumberPlaceholder: '',
                    expiryMonthPlaceholder: 'MM',
                    expiryYearPlaceholder: 'YY',
                    cvvPlaceholder: '',
                  },
                  style: {
                    base: {
                      fontSize: '1.125rem',
                      fontWeight: 500,
                      marginBottom: '1rem',
                      input: {
                        marginTop: '0.5rem',
                      },
                    },
                  },
                }}
                ready={() => {}}
                frameActivated={(e) => {
                  setFrameIsLoading(false);
                }}
                frameFocus={(e) => {}}
                frameBlur={(e) => {}}
                frameValidationChanged={(e) => {
                  setErrors(e);
                }}
                paymentMethodChanged={(e) => {}}
                cardValidationChanged={(e) => {}}
                cardSubmitted={() => {}}
                cardTokenized={(e) => {
                  saveCard(e.token);
                }}
                cardTokenizationFailed={(e) => {}}>
                <h2 className={styles.inputTitles}>{AddCardFormContent.cardNumberTitleText}</h2>
                {showValidationErrors && cardNumberError && (
                  <div className={`coop-c-form-error__text`}>Card number invalid or missing.</div>
                )}
                <CardNumber className={`coop-form__input ${styles.inputField}`} data-testid="card-number-input" />
                <h2 className={styles.inputTitles}>{AddCardFormContent.cardExpiryTitleText}</h2>
                {showValidationErrors && cardExpiryError && (
                  <div className={`coop-c-form-error__text`}>Expiry date invalid or missing.</div>
                )}
                <ExpiryDate className={`coop-form__input ${styles.inputField}`} data-testid="expiry-date-input" />
                <h2 className={styles.inputTitles}>{AddCardFormContent.cardCVVTitleText}</h2>
                {showValidationErrors && CVVError && <div className={`coop-c-form-error__text`}>CVV invalid.</div>}
                <Cvv className={`coop-form__input ${styles.inputField}`} data-testid="cvv-input" />
                {displayCVVInfo()}
              </Frames>
            </div>
            <button
              className={`coop-btn coop-btn--primary coop-c-hero__cta ${styles.submit}`}
              onClick={() => {
                setShowValidationErrors(true);
                Frames.submitCard();
              }}>
              {AddCardFormContent.saveCardText}
            </button>
          </>
        )}
      </div>
    </>
  );
};

AddNewCheckoutCardForm.propTypes = {
  scriptLoading: PropTypes.bool.isRequired,
  frameLoading: PropTypes.bool.isRequired,
};

AddNewCheckoutCardForm.defaultProps = {
  scriptLoading: true,
  frameLoading: true,
};

export default AddNewCheckoutCardForm;
